import { Button, Form } from 'antd';
import { memo } from 'react';
import { useForm } from './context';
import { buildPaymentSummaryView } from './helper';

type Props = {
  disabled: boolean;
  loading: boolean;
};

/**
 * Resumo + CTA, logo acima do botão (Fase 1 do showcase). Mantém o total do método/parcela
 * SELECIONADO visível junto do pagamento e leva o valor pro próprio botão. Trata avulso, múltiplos
 * pagamentos e recorrência (assinatura/adesão) via `buildPaymentSummaryView`.
 */
const PaymentSummary = memo<Props>(({ disabled, loading }) => {
  const { form, getTotal, items, isRecurrence, firstItem, checkout } = useForm();
  const payments = Form.useWatch(['payments'], form) as any[] | undefined;

  const view = buildPaymentSummaryView({
    payments,
    isRecurrence,
    firstItem,
    items,
    fallbackTotal: getTotal() / 100.0,
    freeInstallments: checkout?.freeInstallments,
  });

  return (
    <div className="mt-6 space-y-3">
      <div className="flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 p-3">
        <div className="flex min-w-0 flex-col leading-tight">
          <span className="text-xs text-gray-500">{view.labelText}</span>
          {view.detailText && <span className="truncate text-sm text-gray-600">{view.detailText}</span>}
        </div>
        <span className="text-lg font-semibold text-black">{view.amountText}</span>
      </div>

      <Button
        htmlType="submit"
        type="primary"
        block
        size="large"
        disabled={disabled}
        loading={loading}
      >
        {view.ctaText}
      </Button>
    </div>
  );
});

PaymentSummary.displayName = 'PaymentSummary';

export default PaymentSummary;
